import type { ReactNode } from "react";
import { Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

interface PageHeaderProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

/** Consistent page title styling for main views. */
export function PageHeader({ children, sx }: PageHeaderProps) {
  return (
    <Typography
      variant="h5"
      sx={{
        fontWeight: "bold",
        mb: 3,
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}
